import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import api from "@/lib/api";
import { useAuth } from "@/contexts/AuthContext";
import { CheckCircle2, Loader2 } from "lucide-react";

export default function BillingSuccess() {
  const [params] = useSearchParams();
  const sid = params.get("session_id");
  const { refreshMe } = useAuth();
  const [status, setStatus] = useState("pending");
  const [tries, setTries] = useState(0);
  const nav = useNavigate();

  useEffect(() => {
    if (!sid) return;
    let cancelled = false;
    let attempts = 0;
    const poll = async () => {
      if (cancelled || attempts >= 8) return;
      attempts += 1;
      setTries(attempts);
      try {
        const { data } = await api.get(`/subscriptions/checkout/status/${sid}`);
        if (data.payment_status === "paid") {
          setStatus("paid");
          await refreshMe();
          return;
        }
        if (data.status === "expired") { setStatus("expired"); return; }
      } catch {}
      setTimeout(poll, 2000);
    };
    poll();
    return () => { cancelled = true; };
  }, [sid, refreshMe]);

  return (
    <div className="min-h-[60vh] flex items-center justify-center">
      <div className="bg-white border border-neutral-200 p-8 max-w-md w-full text-center" data-testid="billing-success">
        {status === "paid" ? (
          <>
            <CheckCircle2 size={48} className="text-green-600 mx-auto" />
            <h1 className="font-display font-bold text-3xl tracking-tighter mt-4">Payment successful</h1>
            <p className="text-sm text-neutral-600 mt-2">Your account has been updated.</p>
            <button onClick={() => nav("/teacher")} className="mt-6 bg-[#0A0C10] text-white font-bold px-6 py-3">Back to dashboard</button>
          </>
        ) : status === "expired" ? (
          <>
            <h1 className="font-display font-bold text-2xl tracking-tighter">Session expired</h1>
            <p className="text-sm text-neutral-600 mt-2">Please try again from the billing page.</p>
            <button onClick={() => nav("/teacher/billing")} className="mt-6 bg-[#0A0C10] text-white font-bold px-6 py-3">Back to billing</button>
          </>
        ) : (
          <>
            <Loader2 size={36} className="text-[#002FA7] mx-auto animate-spin" />
            <h1 className="font-display font-bold text-2xl tracking-tighter mt-4">Confirming your payment…</h1>
            <p className="text-sm text-neutral-600 mt-1">Attempt {tries} of 8</p>
          </>
        )}
      </div>
    </div>
  );
}
